import React from "react";
import Image from "next/image";
import styles from "./styles.module.scss";

function NoPostsFallbackIllustration() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 120 120"
            fill="none"
            className={styles.illustration}
            aria-hidden="true"
        >
            <rect x="20" y="30" width="64" height="76" rx="6" fill="#E5E7EB" />
            <rect
                x="28"
                y="22"
                width="64"
                height="76"
                rx="6"
                fill="#F3F4F6"
                stroke="#D1D5DB"
                strokeWidth="1.5"
            />
            {/* Lines representing text */}
            <rect x="40" y="42" width="40" height="5" rx="2.5" fill="#D1D5DB" />
            <rect x="40" y="54" width="32" height="5" rx="2.5" fill="#D1D5DB" />
            <rect x="40" y="66" width="36" height="5" rx="2.5" fill="#D1D5DB" />
            {/* Magnifying glass */}
            <circle
                cx="82"
                cy="80"
                r="16"
                fill="white"
                stroke="#9CA3AF"
                strokeWidth="3"
            />
            <line
                x1="93"
                y1="91"
                x2="104"
                y2="102"
                stroke="#9CA3AF"
                strokeWidth="3"
                strokeLinecap="round"
            />
            {/* X mark inside magnifier */}
            <line
                x1="76"
                y1="74"
                x2="88"
                y2="86"
                stroke="#9CA3AF"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
            <line
                x1="88"
                y1="74"
                x2="76"
                y2="86"
                stroke="#9CA3AF"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
        </svg>
    );
}

interface NoPostsCardProps {
    text?: string;
    image?: string;
}

export default function NoPostsCard({
    text = "No Articles Found",
    image,
}: NoPostsCardProps) {
    return (
        <div className={styles.wrapper}>
            {image ? (
                <div className={styles.imageContainer}>
                    <Image src={image} layout="fill" alt="" />
                </div>
            ) : (
                <NoPostsFallbackIllustration />
            )}
            <p className={styles.text}>{text}</p>
        </div>
    );
}
